import { FC, useEffect } from 'react';

import Policy from '../../components/Desktop/Policy';

/** Terms of service page backed by Termageddon-hosted content. */
const Terms: FC = () => {
  useEffect(() => {
    document.title = 'HomeCook | Terms of Service';
  }, []);

  return (
    <div className="flex h-[900px] flex-col justify-start overflow-y-auto sm:h-screen">
      <p className="text-md mx-auto mt-[90px] font-raleway font-semibold text-primaryDark-200">
        Terms of Service
      </p>
      <div className="mx-auto w-11/12 font-open-sans font-medium">
        <Policy policyKey={process.env.REACT_APP_TERMS_OF_SERVICE_KEY} />
      </div>
    </div>
  );
};

export default Terms;
